export default __webpack_public_path__ + "static/media/collapse-arrow.c706b0bb.svg";